import { lazyInitialize } from 'core-decorators'

const [
    _id,
    _rect,
    _component,
    _slotPool,
] = [
    Symbol('_id'),
    Symbol('_rect'),
    Symbol('_component'),
    Symbol('_slotPool'),
]
class Slot {
    /**
     * 构造方法
     * @param options {Object} 构造参数
     * @param options.id {Number=} 插槽id
     * @param options.rect {Object=} rect配置
     * @param options.component {Template=} 初始化插入插槽的组件
     * @param options.hostContainer {Template|NativeComponent} 宿主容器
     */
    constructor(options = {
        id: undefined,
        rect: undefined,
        component: undefined,
        hostContainer: undefined
    }) {
        const {rect, component, id, hostContainer} = options
        id && this.setId(id)
        rect && this.setRect(rect)
        component && this.slotIn(component)
        hostContainer && this.setHostContainer(hostContainer)
    }

    /**
     * 设置插槽宽高及定位属性
     * 如果已经被插入组件，则通知组件设置rect
     * @param rect {Object=} rect配置
     */
    setRect(rect){
        this[_rect] = rect
        this[_component] && this[_component].setRect(this[_rect])
    }

    getRect(){
        return this[_rect]
    }

    /**
     * 向该插槽插入组件，如果组件不具备setRect方法，则无法插入成功
     * 如果插槽已经设置rect，则通知组件设置rect
     * @param component {Template=} 插入插槽的组件
     */
    slotIn(component={}){
        if(component.setRect && this.hostContainer){
            this[_rect] && component.setRect(this[_rect])
            this[_component] = component
            //component.appendTo(this.hostContainer, this[_rect])

            this.hostContainer.append(component, this[_rect])
            //component.insertBelowTo(this.hostContainer, this[_rect])
            console.warn("组件插入插槽",component, this.hostContainer)
        }else{
            console.warn("组件不可被插入插槽",component, this.hostContainer)
        }
    }
    /**
     * 向该插槽插入组件，如果组件不具备setRect方法，则无法插入成功
     * 如果插槽已经设置rect，则通知组件设置rect
     * @param component {Template=} 插入插槽的组件
     */
    slotInBelow(component={}){
        if(component.setRect && this.hostContainer){
            this[_rect] && component.setRect(this[_rect])
            this[_component] = component
            component.insertBelowTo(this.hostContainer, this[_rect])
            console.warn("组件插入插槽",component, this.hostContainer)
        }else{
            console.warn("组件不可被插入插槽",component, this.hostContainer)
        }
    }

    /**
     * 拔出插槽
     * 清除插槽内的组件引用
     */
    slotOut(component){
        // if(component && component === this[_component] || !component){
        //     this[_component]
        //         && (this[_component] = undefined)
        //         && this[_component].removeSelf()
        // }
        component && component.removeSelf()
    }

    /**
     * 判断插槽内是否被插入组件
     * @returns {boolean}
     */
    hasSlotted(){
        return !!this[_component]
    }

    setId(id){
        if(!this[_id]) {
            this[_id] = id
            this.id = id
        }else{
            console.warn("插槽已被设置过id")
        }
    }

    /**
     * 设置插槽的宿主容器
     * @param hostContainer {Template|NativeComponent} 插槽的宿主容器
     */
    setHostContainer(hostContainer){
        this.hostContainer = hostContainer
    }

    static [_slotPool] = []

    static _pushSlotPool(){
        console.log('扩充slot池',this[_slotPool])
        return this[_slotPool].push(new Slot(), new Slot(), new Slot())
    }

    static getSlot(){
        console.log('当前池内数量', this[_slotPool].length)
        if(this[_slotPool].length <= 0){
            this._pushSlotPool()
        }
        return this[_slotPool].pop()
    }
}

export default Slot